module.exports = __webpack_public_path__ + "static/media/Powerd-01.d9686bc2.svg";